import { action } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { FacilityOrderExtraSuppliesAddForm } from 'application/facility-order/forms';
import { SubCategoryService } from "application/product/services";
import { FacilityOrderTemplateService } from "application/facility-order/services";
import _ from 'lodash';
import { subCategoriesSort } from 'core/utils';

class FacilityOrderExtraSuppliesAddModalViewStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'facility-order-extra-supplies-add-modal',
            Form: FacilityOrderExtraSuppliesAddForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        const { facilityOrderId, subCategoryId } = resource;
                        const response = await facilityOrderTemplateService.createMasterPatientTemplateBySubCategory(subCategoryId, facilityOrderId);
                        this.patient = response.data.patient;
                        return response.data;
                    }
                }
            },
            FormClass: FacilityOrderExtraSuppliesAddForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;

        this.facilityOrderId = this.modalParams.data.facilityOrderId;

        this.subCategoryStore = new BaasicDropdownStore({}, {
            fetchFunc: async (term) => {
                const subCategorysAbrv = ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube","Urologicals", "Ostomy-Products", "Wound-Care"];
                const response = await subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory"});
                let data =  subCategoriesSort(response.data.item.map(i=> {return {...i, name: `${i.name}`}}));
                let filteredSubCategories = _.filter(data, i => {
                    return subCategorysAbrv.some(s => i.abrv === s);
                });

                return filteredSubCategories;
            }
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.create({
                ...resource,
                facilityOrderId: this.facilityOrderId
            });
            this.form.setFieldsDisabled(false);
            this.goToPatientTemplates();
            this.modalParams.close();

            this.rootStore.notificationStore.success('Template successfully generated.');
        } 
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to create a template.');
        }
    }

    @action.bound
    goToPatientTemplates() {
		this.rootStore.routerStore.goTo(
			'master.app.main.facility-order.facility-order-template.edit', {
                patientId: this.patient.id,
                patientKey: this.patient.patientKey,
                facilityOrderId: this.facilityOrderId,
            },
		);
    }
}

export default FacilityOrderExtraSuppliesAddModalViewStore;
